/**
 * Shared ArcGIS Portal configuration.
 * Values that are the same across all environments live here so only
 * the app-specific appId needs to appear in each app-config*.json.
 */

/** Base domain of the ArcGIS enterprise server. */
export const GIS_PORTAL_BASE = 'https://gis.xom.cloud';

/** Path to the Portal web-adaptor — appended to GIS_PORTAL_BASE for all OAuth endpoints. */
export const GIS_PORTAL_PATH = '/portal';

/**
 * Requested token lifetime in minutes.
 * Must be > 30 for the portal to issue a refresh token that outlives the
 * 30-minute access token, enabling silent background renewal.
 */
export const GIS_TOKEN_EXPIRATION = 1440; // 1 day
